export default function ({app, error}) {
  if (!app.$hasPermission('accept_from_ls')) {
    return error({
      message: '権限がありません。',
      redirectPath: app.$redirectPathDefault(),
      redirectText: 'メインメニュー'
    });
  }
}